<template>
  <app-layout>
    <template #header>
      <AppHead title="Invoice" />
      <h2 class="title">Payment #{{ payment.id }}</h2>
      <flash-messages />
    </template>

    <section class="mt-3">

      <div class="row">
        <div class="col-12 col-md-6 col-lg-4">
          <card title="Receipt" class="mb-3">
            <ul class="list-unstyled mb-0">
              <li class="d-flex justify-content-between">Payment Amount: <span class="text-secondary">{{ formatDollars(this.payment.total) }}</span></li>
              <template v-if="payment.ach_discount > 0">
                <li class="d-flex justify-content-between">You Saved: <span class="text-secondary">-{{ formatDollars(this.payment.ach_discount) }}</span></li>
                <li><span class="text-secondary">({{ Math.round((this.payment.ach_discount / this.payment.total) * 100, 0) }}% discount when paying by bank account)</span></li>
                <li class="d-flex justify-content-between">Amount Charged: <span class="text-secondary">{{ formatDollars(this.payment.amount) }}</span></li>
              </template>
              <li class="d-flex justify-content-between">Date Paid <span class="text-secondary">{{ moment(this.payment.transaction_date).format('M/D/YY h:mma') }}</span></li>
              <jet-button @click="openPrintReceipt" icon="fas fa-file-invoice-dollar" class="mt-2">Print Receipt</jet-button>
            </ul>
          </card>

          <div v-if="payment.payment_method">
            <card title="Payment Method">
              <div v-if="payment.type == 'Cash' || payment.type == 'Check'">
                <p class="mb-1 font-weight-bold">{{ payment.type }} {{ payment.check_number ? '#' + payment.check_number : '' }} Accepted</p>
                <p class="mb-0" v-if="payment.cash_session_item">Cash Tendered: <span class="text-success">{{ formatDollars(payment.cash_session_item.credit_amount) }}</span></p>
                <p class="mb-0" v-if="payment.cash_session_item">Change: <span class="text-success">{{ formatDollars(payment.cash_session_item.debit_amount) }}</span></p>
              </div>
              <div v-else-if="payment.payment_method?.cc_image_url" class="text-secondary text-size-small">
                <img :src="payment.payment_method.cc_image_url" :alt="payment.payment_method.brand" width="32"/> ending in {{ payment.payment_method.last4 }}
              </div>
              <div v-else-if="payment.type == 'ACH'">
                <p class="mb-0">{{ payment.payment_method.bank_name }} <span class="text-secondary text-size-small">ending in {{ payment.payment_method.last4 }}</span></p>
              </div>
            </card>
          </div>
        </div>

        <div class="col-12 col-md-6 col-lg-8">
          <card title="Account Balance" class="mb-3">
            <div class="row balance-table">
            <div class="col-12 col-lg-2">
              <strong>Payment</strong>
              <h3>{{ formatDollars(payment.total, 2) }}</h3>
            </div>
            <div class="col-12 col-lg-5">
              <strong>New Account Balance</strong>
              <h3>{{ formatDollars(payment.payer_user.accountBalance, 2) }}</h3>
            </div>
          </div>
          </card>
        </div>
      </div>
    </section>

    <teleport to="body">
      <PrintModal :printUrl="printUrl" @print="printReceipt" />
    </teleport>
  </app-layout>
</template>

<script>
  import AppLayout from '@/Layouts/AppLayout'
  import PrintModal from '@/Components/Modals/PrintModal'
  import moment from 'moment'

  export default {
    components: {
      AppLayout,
      PrintModal
    },
    props: {
      payment: Object,
      user: Object,
    },
    data() {
      return {
        printUrl: null
      }
    },
    created() {
      this.moment = moment;
    },
    methods: {
      openPrintReceipt() {
        this.printUrl = this.route('mtd.payment.receipt', this.payment.id);
        $('#PrintModal').modal('show');
      },
      printReceipt() {
        this.printUrl = this.route('mtd.payment.receipt', {payment: this.payment.id, print: 1});
      },
    }
  }
</script>